export default "__VITE_ASSET__orMSijlx__"